import clsx from "clsx";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  /** Constrain width to theme content-max-width */
  constrainWidth?: boolean;
}

export function Card({ children, className, constrainWidth }: CardProps) {
  return (
    <div
      className={clsx(
        "border-card rounded-card bg-card section-padding",
        constrainWidth && "max-content-width w-full",
        className
      )}
    >
      {children}
    </div>
  );
}
